/*
 * action types
 */

export const types = {
  GET_PROFILE: 'GET_PROFILE',
  REFRESH_PROFILE: 'REFRESH_PROFILE',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE: 'GET_PROFILE_FAILURE',
  RESET_PROFILE: 'RESET_PROFILE'
};

/*
 * action creators
 */

export function getProfile() {
  return { type: types.GET_PROFILE };
}

export function refreshProfile() {
  return { type: types.REFRESH_PROFILE };
}

export function getProfileSuccess(profile) {
  return { type: types.GET_PROFILE_SUCCESS, profile };
}

export function getProfileFailure(error) {
  return { type: types.GET_PROFILE_FAILURE, error };
}

export function resetProfile() {
  return { type: types.RESET_PROFILE };
}
